export const footer = {
  contact_member_services: 'Contact Member Services',
  copyright: `© ${new Date().getFullYear().toString()} Christian Care Ministry`,
  disclaimer_body: `Medi-Share is a nonprofit health care sharing ministry of Christian Care Ministry, Inc ("CCM"). Medi-Share members voluntarily share each other's medical expenses in accordance with guidelines adopted by the members and administered by CCM.
  <br />
  <br />
  Medi-Share is not insurance and is not regulated as insurance. Neither CCM nor any Medi-Share member assume any legal obligation to share in the payment of any medical expense incurred by another Medi-Share member. Medi-Share members are exempt from the individual mandate in the Patient Protection and Affordable Care Act. See 26 U.S.C §5000 A(d)(2)(B). Certain states expressly exempt from insurance regulation healthcare sharing ministries that, among other things, post a specific notice. Although Medi-Share does not rely on such express exemptions, Medi-Share has elected to publish these notices. You can review the disclosure required for the state in which you reside: <stateDisclosureLink>KY, MD, PA, WI - All Other States</stateDisclosureLink>.`,
  member_id_cards_button: 'Member ID Cards',
  menu_blog: 'Blog',
  menu_faq: 'FAQ',
  menu_guideines: 'Guidelines',
  menu_national_outreach: 'National Outreach',
  menu_our_ministry: 'Our Ministry',
  menu_privacy_policy: 'Privacy Policy',
  menu_terms_of_use: 'Terms of Use',
  providers_find_button: 'Find Providers',
  quick_links_make_a_share_payment: 'Make a Share Payment',
  quick_links_manage_autopay: 'Manage Autopay',
  quick_links_medical_bill_history: 'Medical Bill History',
  quick_links_member_forms: 'Member Forms',
  quick_links_program_summary: 'Program Summary',
  quick_links_schedule_telehealth: 'Schedule Telehealth',
  quick_links_share_notices: 'Share Notices',
  quick_links_title: 'Quick Links',
  quick_links_your_provider_network: 'Your Provider Network',
  version: 'Version',
} as const;

export type FooterNamespace = Record<keyof typeof footer, string>;
